import AssessGroupLearner from "./assessGroupLearner";
import ExcelDownloader from "../utilities/excelDownloader";


function AssessGroup(props) {

  // Define variables
  const viewCode = props.viewCode;
  const group = props.group;
  const groupName = group.name;
  const headings = group.headings;
  const data = group.data;
  const displayCount = headings.filter((item) => !item.exportOnly).length;
  const rowWidth = ((displayCount - 1) * 205) + 135;


  // Screen components
  let emptyElement;
  let exportElement;
  let headingElement;
  const headingData = [];


  if( data.length === 0 ) {
    emptyElement = (
      <div class='flex-row assess-groupd-row'>
        <p style={{marginBottom: 'initial'}}>No learners in this group took an assessment</p>
      </div>
    );
  } else {

    headings.map((heading, index) => {
      if( !heading.exportOnly ) {
        let divClass = 'inner';
        if( heading.name === 'firstName' ) { divClass = 'first-name' }
        if( heading.name === 'delta' ) { divClass = 'delta' }

        headingData.push(<div class={divClass} key={`assess-group-${index}`}>{heading.display}</div>);
      }
    });

    headingElement = (
      <div class='flex-row assess-groupd-row heading' style={{width: rowWidth}}>
        {headingData}
      </div>
    );

    // Export info
    const filename = `${groupName} Assessment Results`;
    exportElement = (
      <div style={{marginBottom: '15px'}}>
        <ExcelDownloader data={data} headings={headings} filename={filename} />
      </div>
    );
  }


  return (
    <div style={{marginTop: '60px'}}>

      <div class='flex-row'>
        <h3 style={{marginBottom: '15px'}}>{groupName}</h3>
        {exportElement}
      </div>


      <div class='assess-groupd-container-wrapper'>

        {headingElement}

        {data.map((learner, index) =>
          <AssessGroupLearner
            key={`assess-grouped-learner-${index}`}
            headings={headings}
            learner={learner}
            viewCode={viewCode}
            rowWidth={rowWidth}
          />
        )}

        {emptyElement}
      </div>
    </div>
  );
}

export default AssessGroup;
